import React, { useState } from "react";
import { toast } from "sonner";
import { PageHeader } from "@/components/shared";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/lib/i18n";

export default function Profile() {
  const { t } = useI18n();
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ name: user?.name || "", mobile: user?.mobile || "" });
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { data } = await api.put("/profile", form);
      setUser(data); toast.success("Profile updated");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div>
      <PageHeader title={t("profile")} subtitle="Manage your personal information." />
      <form onSubmit={save} className="ec-card p-6 sm:p-8 space-y-5 max-w-lg">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-orange-500/20 flex items-center justify-center font-head font-extrabold text-2xl text-orange-400 uppercase">{user?.name?.[0] || "U"}</div>
          <div><p className="font-head font-bold text-white text-lg">{user?.name}</p><p className="text-sm text-gray-500 keep-ltr">{user?.email}</p></div>
        </div>
        <div><Label>{t("name")}</Label><Input data-testid="profile-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1" /></div>
        <div><Label>{t("mobile")}</Label><Input data-testid="profile-mobile" value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} className="mt-1" /></div>
        <div><Label>{t("referral_code")}</Label><Input readOnly value={user?.referral_code || ""} className="mt-1 keep-ltr opacity-70" /></div>
        <Button type="submit" disabled={busy} data-testid="profile-save" className="bg-orange-600 hover:bg-orange-500 btn-glow font-semibold px-8">{busy ? "..." : t("save")}</Button>
      </form>
    </div>
  );
}
